import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
	  isPlay: false,
  },
  getters: {
	  isPlay(state){
		  return state.isPlay
	  }
  },
  mutations: {
	  play(state){
		  state.isPlay = true;
	  },
	  stop(state){
		  state.isPlay = false;
	  }
  },
  actions: {
  },
  modules: {
  }
})
